/*
 * Rove Hotels Corporate
 */
function factory({ window, document, thn }) {
    const engine = {};
    const corpoBookingPage = window.location.hostname.includes('search');
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let lang;
            if (corpoBookingPage) {
                const langElement = document.querySelector('#international-translation-bar-id .intl-label .labels.ng-binding.ng-scope');
                lang = langElement?.textContent?.slice(0, 2) === 'En' ? 'en' : 'ar';
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
            }
            else {
                lang = window.location.pathname.match(ctx.urlRe);
                lang = lang && lang.length && lang[1];
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                }
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_1042724
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const langContainer = document.querySelector('#international-translation-bar-id');
        if (langContainer && corpoBookingPage) {
            const refreshLang = thn.debounce(thn.languageCheck, 150);
            thn.observeDom(langContainer, refreshLang, {
                attributes: true,
            });
            thn.shutdown(() => {
                refreshLang.cancel();
                thn.stopObserveDom(langContainer, refreshLang);
            });
        }
    };
    return engine;
}

export { factory };
